import { createFileRoute } from "@tanstack/react-router";
import AnthemBcbsIndianaInsurance, {
  config,
} from "@/pages/AnthemBcbsIndianaInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/anthem-bcbs-indiana-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Anthem BCBS Indiana TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Anthem BCBS Indiana coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Anthem BCBS Indiana TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Anthem BCBS Indiana coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/anthem-bcbs-indiana-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/anthem-bcbs-indiana-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AnthemBcbsIndianaInsurance />;
}
